export default __webpack_public_path__ + "3beee195f39894063c08bfcf20a3929d.png";